import Vue from 'vue'
import App from './App.vue'
import router from './router/index' // 导入路由配置
import Vant from 'vant' // 导入Vant组件库
import 'vant/lib/index.css' // 导入Vant样式

Vue.use(Vant) // 使用Vant组件库
Vue.config.productionTip = false

new Vue({
  router, // 使用路由
  render: h => h(App),
}).$mount('#app')
